/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Unregister_Only_SelfInputs */



/**
* | output |
* | --- |
* | "You can only unregister yourself" |
*
* @param {Err_Tournament_Unregister_Only_SelfInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_unregister_only_self = /** @type {((inputs?: Err_Tournament_Unregister_Only_SelfInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Unregister_Only_SelfInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ne pouvez vous désinscrire que vous-même")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo puede cancelar su propia inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você só pode cancelar sua própria inscrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Puoi annullare solo la tua iscrizione")
	return /** @type {LocalizedString} */ ("You can only unregister yourself")
});